import { getLocalStorage } from './localStorageService';
import { CompanyResponseModel } from '@models/login/companyResponseModel';
import { AppContextConstants } from '@constants/appContextConstants';
import { UserInformationModel } from '@models/login/userInformationModel';

const AUTH_STORAGE_KEY = AppContextConstants.AUTH_STORAGE_KEY;

const validateCompanyInfo = (info: unknown): info is CompanyResponseModel => {
  if (!info || typeof info !== AppContextConstants.OBJECT) return false;

  const requiredFields: string[] = [
    AppContextConstants.CONTACT_NAME_AND_ADDRESS,
    AppContextConstants.CONTACT_PHONE,
    AppContextConstants.CONTACT_EMAIL,
    AppContextConstants.CONTACT_FAX,
    AppContextConstants.CONTACT_URL,
    AppContextConstants.CONTACT_LOGO_PATH,
    AppContextConstants.PUBLISH_NAME,
  ];

  return requiredFields.every(
    field => field in (info as Record<string, unknown>)
  );
};

export interface AuthState {
  user: UserInformationModel | null;
  companyInfo: CompanyResponseModel | null;
  isAuthorized: boolean;
  companyId: string;
}

export const getInitialState = async (): Promise<AuthState> => {
  const stored = (await getLocalStorage(
    AUTH_STORAGE_KEY
  )) as Partial<AuthState>;

  return {
    user: stored?.user ?? null,
    companyInfo: validateCompanyInfo(stored?.companyInfo)
      ? stored.companyInfo
      : null,
    isAuthorized: stored?.isAuthorized ?? false,
    companyId: stored?.companyId ?? AppContextConstants.EMPTY_STRING,
  };
};
